(function () {
  function initTeamDiscount() {
    var container = document.querySelector('[data-team-discount]');
    if (!container || container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    var tiers;
    try {
      tiers = JSON.parse(container.getAttribute('data-team-tiers') || '[]');
    } catch (e) {
      return;
    }
    if (!tiers || !tiers.length) return;

    var form = container.closest('.product_form') || container.closest('form');
    var qtyInput = form
      ? form.querySelector('input.quantity, input[name="quantity"]')
      : document.querySelector('input.quantity, input[name="quantity"]');
    if (!qtyInput) return;

    var progressBar = container.querySelector('[data-progress-bar]');
    var feedbackCard = container.querySelector('[data-feedback-card]');
    var shippingStatus = container.querySelector('[data-shipping-status]');
    var teamSavings = container.querySelector('[data-team-savings]');
    var tierCards = container.querySelectorAll('.tier-item');
    var rosterToggle = container.querySelector('[data-roster-toggle]');
    var rosterPanel = container.querySelector('[data-roster-panel]');
    var rosterInputs = container.querySelectorAll('[data-roster-input]');
    var rosterRows = container.querySelectorAll('[data-roster-row]');
    var rosterRowsContainer = container.querySelector('[data-roster-rows]');
    var rosterAddButton = container.querySelector('[data-roster-add]');
    var rosterPasteInput = container.querySelector('[data-roster-paste]');
    var rosterCopyButton = container.querySelector('.roster-copy-invite');
    var modeTabs = container.querySelectorAll('[data-mode]');
    var modePanels = container.querySelectorAll('[data-panel]');
    var personalRequiredInputs = container.querySelectorAll('[data-personal-required]');
    var currentMode = 'team';
    var deliveryWindowEl = container.querySelector('[data-delivery-window]') ||
      (form ? form.querySelector('[data-delivery-window]') : null) ||
      document.querySelector('[data-delivery-window]');
    var quantityWrap = form ? form.querySelector('[data-quantity-wrap]') : null;
    var quantityNote = container.querySelector('[data-team-quantity-note]') || (form ? form.querySelector('[data-team-quantity-note]') : null);
    var unitPrice = parseInt(container.getAttribute('data-unit-price'), 10) || 0;
    var moneyFormat = (form && form.getAttribute('data-money-format')) ||
      (document.body && document.body.getAttribute('data-money-format')) ||
      null;
    var shippingThreshold = parseInt(container.getAttribute('data-shipping-threshold'), 10) || 9900;
    var maxTierMin = parseInt(container.getAttribute('data-max-tier'), 10) || 20;

    qtyInput.readOnly = true;
    qtyInput.setAttribute('aria-readonly', 'true');

    function formatMoney(cents) {
      try {
        if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFormat) {
          return Shopify.formatMoney(cents, moneyFormat);
        }
        return '$' + (cents / 100).toFixed(2);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function getQtyFromInput(inputEl) {
      if (!inputEl) return 1;
      var val = parseInt(inputEl.value, 10);
      return isNaN(val) || val < 1 ? 1 : val;
    }

    function createRosterRow(index) {
      var row = document.createElement('div');
      row.className = 'roster-table__row';
      row.setAttribute('data-roster-row', '');

      var playerNumberInput = document.createElement('input');
      playerNumberInput.type = 'text';
      playerNumberInput.name = 'properties[Player ' + index + ' Number]';
      playerNumberInput.placeholder = 'Player ' + index;

      var jerseyNumberInput = document.createElement('input');
      jerseyNumberInput.type = 'text';
      jerseyNumberInput.name = 'properties[Player ' + index + ' Jersey Number]';
      jerseyNumberInput.placeholder = '#';

      var sizeInput = document.createElement('input');
      sizeInput.type = 'text';
      sizeInput.name = 'properties[Player ' + index + ' Size]';
      sizeInput.placeholder = 'Size';
      sizeInput.setAttribute('data-roster-size', '');

      var caInput = document.createElement('input');
      caInput.type = 'text';
      caInput.name = 'properties[Player ' + index + ' C/A]';
      caInput.placeholder = 'C or A';

      var removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'roster-remove-row';
      removeButton.setAttribute('data-roster-remove', '');
      removeButton.setAttribute('aria-label', 'Remove player');
      removeButton.textContent = '×';

      row.appendChild(playerNumberInput);
      row.appendChild(jerseyNumberInput);
      row.appendChild(sizeInput);
      row.appendChild(caInput);
      row.appendChild(removeButton);

      return row;
    }

    function ensureRosterRows(qty) {
      if (!rosterRowsContainer) return;
      var currentCount = rosterRowsContainer.querySelectorAll('[data-roster-row]').length;
      var target = qty < 1 ? 1 : qty;
      if (target > currentCount) {
        for (var i = currentCount + 1; i <= target; i++) {
          rosterRowsContainer.appendChild(createRosterRow(i));
        }
      } else if (target < currentCount) {
        for (var r = currentCount; r > target; r--) {
          var lastRow = rosterRowsContainer.querySelector('[data-roster-row]:last-child');
          if (lastRow) {
            rosterRowsContainer.removeChild(lastRow);
          }
        }
      }
      rosterRows = container.querySelectorAll('[data-roster-row]');
    }

    function syncRosterRows(qty) {
      if (!rosterRowsContainer) return qty;
      var clampedQty = qty < 1 ? 1 : qty;
      ensureRosterRows(clampedQty);
      rosterRows.forEach(function (row) {
        row.classList.remove('is-hidden');
      });
      if (parseInt(qtyInput.value, 10) !== clampedQty) {
        qtyInput.value = clampedQty;
      }
      return clampedQty;
    }

    function updateAll() {
      var qty = getQtyFromInput(qtyInput);
      qty = syncRosterRows(qty);
      var savingsTitle = 'Team Savings';
      if (qty >= 10) {
        savingsTitle = "🏆 Captain's Elite Price";
      } else if (qty >= 5) {
        savingsTitle = "Squad Leader's Price";
      }
      
      // --- 1. 进度条：按刻度(1,5,10,15,20)线性插值 ---
      if (progressBar) {
        var ticks = [1, 5, 10, 15, 20];
        var percents = [0, 25, 50, 75, 100];

        var clampedQty = qty;
        if (clampedQty < ticks[0]) clampedQty = ticks[0];
        if (clampedQty > ticks[ticks.length - 1]) clampedQty = ticks[ticks.length - 1];

        var percent = 0;
        for (var t = 0; t < ticks.length - 1; t++) {
          var leftTick = ticks[t];
          var rightTick = ticks[t + 1];
          if (clampedQty >= leftTick && clampedQty <= rightTick) {
            var ratio = (clampedQty - leftTick) / (rightTick - leftTick);
            percent = percents[t] + ratio * (percents[t + 1] - percents[t]);
            break;
          }
        }

        progressBar.style.transition = 'width 0.3s ease';
        progressBar.style.width = percent + '%';
        progressBar.classList.toggle('is-elite', qty >= 20);
      }

      var currentTierIndex = -1;

      // 2. 找到当前档位的索引
      for (var i = 0; i < tiers.length; i++) {
        var min = parseInt(tiers[i].min, 10);
        var maxAttr = tiers[i].max;
        var max = (maxAttr === null || maxAttr === "" || maxAttr === "null") ? Infinity : parseInt(maxAttr, 10);

        if (qty >= min && qty <= max) {
          currentTierIndex = i;
          break;
        }
      }

      if (currentTierIndex === -1) currentTierIndex = tiers.length - 1;

      var currentTier = tiers[currentTierIndex];
      var nextTier = tiers[currentTierIndex + 1] || null;

      // 3. 更新档位卡片激活状态
      tierCards.forEach(function (card, index) {
        if (index === currentTierIndex) {
          card.classList.add('active');
        } else {
          card.classList.remove('active');
        }
      });

      // 4. 计算金额
      var currentDiscount = parseFloat(currentTier.discount) || 0;
      var discountedUnit = Math.round(unitPrice * (1 - currentDiscount / 100));
      var total = discountedUnit * qty;
      var retailTotal = unitPrice * qty;
      var savingsTotal = Math.max(0, retailTotal - total);

      // 5. 动态差额提醒 (已整合居中样式)
      if (feedbackCard && shippingStatus) {
        var nudgeText = "";
        if (nextTier) {
          var itemsToNext = nextTier.min - qty;
          nudgeText = '<span style="display:block; font-size:11px; margin-top:6px; font-weight:normal; opacity:0.9; text-align:center; width:100%;">Add <b>' + itemsToNext + '</b> more to unlock <b>' + nextTier.discount + '% OFF</b></span>';
        } else {
          nudgeText = '<span style="display:block; font-size:11px; margin-top:6px; font-weight:normal; opacity:0.9; text-align:center; width:100%;">🏆 <b>MAX DISCOUNT REACHED</b></span>';
        }

        if (qty >= 20) {
          nudgeText = '<span style="display:block; font-size:11px; margin-bottom:4px; font-weight:700; text-align:center; width:100%;">Elite Captain Status Unlocked! 🏆</span>' + nudgeText;
        } else if (qty >= 10) {
          nudgeText = '<span style="display:block; font-size:11px; margin-bottom:4px; font-weight:700; text-align:center; width:100%;">Your team is growing! 🚀</span>' + nudgeText;
        } else if (qty >= 5) {
          nudgeText = '<span style="display:block; font-size:11px; margin-bottom:4px; font-weight:700; text-align:center; width:100%;">Nice! You\'ve started a squad! ⚽</span>' + nudgeText;
        }

        if (total < shippingThreshold) {
          var gap = shippingThreshold - total;
          shippingStatus.innerHTML = '<span class="status-icon">!</span> ADD ' + formatMoney(gap) + ' FOR FREE SHIPPING' + nudgeText;
          feedbackCard.className = 'team-feedback-card is-warning';
        } else {
          var shipIcon = qty >= 10 ? '🚀' : '✓';
          var shipText = qty >= 10 ? 'UPGRADED TO FEDEX PRIORITY' : 'FREE SHIPPING APPLIED';
          shippingStatus.innerHTML = '<span class="status-icon">' + shipIcon + '</span> ' + shipText + nudgeText;
          feedbackCard.className = 'team-feedback-card is-success';
        }
      }

      // 6. 节省金额显示
      if (teamSavings) {
        if (savingsTotal > 0) {
          teamSavings.innerHTML = savingsTitle + ': <strong>' + formatMoney(savingsTotal) + '</strong>';
          teamSavings.style.display = 'block';
        } else {
          teamSavings.innerHTML = 'Add more for <strong>Team Discounts</strong>';
        }
      }
    }

    function updateFromRosterInputs() {
      if (!rosterInputs || rosterInputs.length === 0) return;
      var total = 0;
      rosterInputs.forEach(function (input) {
        var val = parseInt(input.value, 10);
        if (!isNaN(val) && val > 0) {
          total += val;
        }
      });
      var nextQty = total > 0 ? total : 1;
      if (qtyInput && parseInt(qtyInput.value, 10) !== nextQty) {
        qtyInput.value = nextQty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateAll();
      }
    }

    function addRosterRow() {
      if (!rosterRowsContainer) return;
      var currentQty = getQtyFromInput(qtyInput);
      var nextQty = currentQty + 1;
      qtyInput.value = nextQty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateAll();
    }

    function addPlayerRow() {
      addRosterRow();
    }

function parseRosterText(rawText) {
  if (!rawText) return [];
  var lines = rawText.split(/\r?\n+/);
  var results = [];
  
  lines.forEach(function (line) {
    var clean = (line || '').trim();
    if (!clean || /^\[.*\]$/.test(clean)) return;

    // --- 核心优化：匹配图片中的 18 个尺码 ---
    // 这个正则现在支持：
    // 1. Adult: S, M, L, XL, XXL, XXXL, 4XL, 5XL
    // 2. Youth: YOUTH XS, YOUTH S, YOUTH M, YOUTH L, YOUTH XL (及 YXS 等缩写)
    // 3. Toddler: 2T, 3T, 4T, 5T
    var sizeRegex = /(YOUTH\s*(XS|S|M|L|XL)|Y(XS|S|M|L|XL)|[2-5]T|XXXL|[2-5]XL|S|M|L|XL|XXL)/i;
    
    // 分隔逻辑：名字 - 数字 - 尺码
    // 我们使用了更加包容的分隔符匹配 [\s\-/,]+
    var match = clean.match(/^\s*(.+?)[\s\-/,]+#?(\d+)[\s\-/,]+(.*?)$/i);

    if (match) {
      var name = match[1].trim();
      var number = match[2].trim();
      var remainingText = match[3].trim();
      
      // 在剩余文本中精准提取符合尺码表的关键词
      var sizeMatch = remainingText.match(sizeRegex);
      var size = sizeMatch ? sizeMatch[0].toUpperCase() : remainingText.toUpperCase();
      
      results.push({ name: name, number: number, size: size });
    }
  });
  return results;
}

    function applyParsedRoster(entries) {
      if (!rosterRowsContainer || !entries.length) return;

      function isRowEmpty(row) {
        var inputs = row.querySelectorAll('input');
        var hasValue = false;
        inputs.forEach(function (input) {
          if (input.value && input.value.trim() !== '') {
            hasValue = true;
          }
        });
        return !hasValue;
      }

      function getFirstEmptyRow() {
        var rows = rosterRowsContainer.querySelectorAll('[data-roster-row]');
        for (var i = 0; i < rows.length; i++) {
          if (isRowEmpty(rows[i])) return rows[i];
        }
        return null;
      }

      entries.forEach(function (entry) {
        var row = getFirstEmptyRow();
        if (!row) {
          addPlayerRow();
          var rows = rosterRowsContainer.querySelectorAll('[data-roster-row]');
          row = rows[rows.length - 1];
        }
        if (!row) return;
        var nameInput = row.querySelector('input');
        var numberInput = row.querySelector('input:nth-of-type(2)');
        var sizeInput = row.querySelector('[data-roster-size]');

        if (nameInput && entry.name) nameInput.value = entry.name;
        if (numberInput && entry.number) numberInput.value = entry.number;
        if (sizeInput && entry.size) sizeInput.value = entry.size;
      });
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateAll();
      updateQuantityNote();
    }

    function scheduleUpdate(sourceInput) {
      if (sourceInput && sourceInput !== qtyInput) {
        qtyInput = sourceInput;
      }
      setTimeout(updateAll, 50);
    }

    function getInviteMessage() {
      var url = window.location.href;
      return "Hey Team! We're ordering our custom jerseys. Please reply in this format: [Name]-[Number]-[Size].\n\n" +
        "Available Sizes: S, M, L, XL, XXL, 3XL，4XL,5XL\n\n" +
        "Check the design here: " + url;
    }

    function formatDateRange(startDate, endDate) {
      var sameMonth = startDate.getMonth() === endDate.getMonth() &&
        startDate.getFullYear() === endDate.getFullYear();
      var startOptions = { month: 'short', day: 'numeric' };
      var endOptions = { month: 'short', day: 'numeric', year: 'numeric' };
      var startText = startDate.toLocaleDateString('en-US', sameMonth ? startOptions : endOptions);
      var endText = endDate.toLocaleDateString('en-US', endOptions);
      return startText + ' – ' + endText;
    }

    function updateDeliveryWindow() {
      if (!deliveryWindowEl) return;
      var today = new Date();
      var earliest = new Date(today);
      earliest.setDate(earliest.getDate() + 21);
      var latest = new Date(today);
      latest.setDate(latest.getDate() + 35);
      deliveryWindowEl.textContent = formatDateRange(earliest, latest);
    }

    function updateQuantityNote() {
      if (!quantityNote) return;
      if (currentMode !== 'team') {
        quantityNote.setAttribute('hidden', '');
        quantityNote.textContent = '';
        return;
      }
      if (!rosterRowsContainer) return;
      var counts = {};
      var total = 0;
      var rows = rosterRowsContainer.querySelectorAll('[data-roster-row]');

      rows.forEach(function (row) {
        var sizeInput = row.querySelector('[data-roster-size]');
        if (!sizeInput || !sizeInput.value) return;
        var size = sizeInput.value.trim().toUpperCase();
        if (!size) return;
        total += 1;
        counts[size] = (counts[size] || 0) + 1;
      });

      if (total === 0) {
        quantityNote.setAttribute('hidden', '');
        quantityNote.textContent = '';
        return;
      }

      var orderedSizes = ['S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
      var parts = [];
      orderedSizes.forEach(function (size) {
        if (counts[size]) {
          parts.push(size + ' × ' + counts[size]);
        }
      });

      Object.keys(counts).forEach(function (size) {
        if (orderedSizes.indexOf(size) === -1) {
          parts.push(size + ' × ' + counts[size]);
        }
      });

      quantityNote.removeAttribute('hidden');
      quantityNote.textContent = 'Total Quantity: ' + total + ' (Based on roster) — ' + parts.join(', ');
    }

    function setMode(mode) {
      if (!mode) return;
      currentMode = mode;

      if (modeTabs && modeTabs.length) {
        modeTabs.forEach(function (tab) {
          tab.classList.toggle('active', tab.getAttribute('data-mode') === mode);
        });
      }

      if (modePanels && modePanels.length) {
        modePanels.forEach(function (panel) {
          panel.classList.toggle('active', panel.getAttribute('data-panel') === mode);
        });
      }

      if (personalRequiredInputs && personalRequiredInputs.length) {
        personalRequiredInputs.forEach(function (input) {
          if (mode === 'personal') {
            input.setAttribute('required', 'required');
          } else {
            input.removeAttribute('required');
          }
        });
      }

      if (quantityWrap) {
        if (mode === 'team') {
          quantityWrap.setAttribute('hidden', '');
        } else {
          quantityWrap.removeAttribute('hidden');
        }
      }

      if (mode === 'team') {
        qtyInput.readOnly = true;
        qtyInput.setAttribute('aria-readonly', 'true');
      } else {
        qtyInput.readOnly = false;
        qtyInput.removeAttribute('aria-readonly');
      }

      if (mode === 'personal') {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateAll();
        updateQuantityNote();
        return;
      }

      if (rosterRowsContainer) {
        var rowCount = rosterRowsContainer.querySelectorAll('[data-roster-row]').length;
        var nextQty = rowCount > 0 ? rowCount : 1;
        qtyInput.value = nextQty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateAll();
      updateQuantityNote();
    }

    qtyInput.addEventListener('change', updateAll);
    qtyInput.addEventListener('input', updateAll);

    if (form && rosterRowsContainer) {
      form.addEventListener('submit', function (e) {
        if (currentMode === 'personal') return;
        var rows = rosterRowsContainer.querySelectorAll('[data-roster-row]');
        if (!rows.length) return;

        var firstInvalidIndex = -1;
        rows.forEach(function (row, index) {
          var inputs = row.querySelectorAll('input');
          var sizeInput = row.querySelector('[data-roster-size]');
          var hasAnyValue = false;

          inputs.forEach(function (input) {
            input.classList.remove('roster-input-error');
            if (input.value && input.value.trim() !== '') {
              hasAnyValue = true;
            }
          });

          if (hasAnyValue && sizeInput && (!sizeInput.value || sizeInput.value.trim() === '')) {
            sizeInput.classList.add('roster-input-error');
            if (firstInvalidIndex === -1) {
              firstInvalidIndex = index + 1;
            }
          }
        });

        if (firstInvalidIndex !== -1) {
          e.preventDefault();
        }
      });
    }

    if (rosterToggle && rosterPanel) {
      rosterToggle.addEventListener('click', function () {
        if (currentMode === 'personal') return;
        var isHidden = rosterPanel.hasAttribute('hidden');
        if (isHidden) {
          rosterPanel.removeAttribute('hidden');
          rosterToggle.setAttribute('aria-expanded', 'true');
        } else {
          rosterPanel.setAttribute('hidden', '');
          rosterToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    if (rosterAddButton && rosterRowsContainer) {
      rosterAddButton.addEventListener('click', addPlayerRow);
    }

    if (modeTabs && modeTabs.length) {
      modeTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var mode = tab.getAttribute('data-mode');
          setMode(mode);
        });
      });

      var defaultMode = 'personal';
      modeTabs.forEach(function (tab) {
        if (tab.classList.contains('active')) {
          defaultMode = tab.getAttribute('data-mode') || defaultMode;
        }
      });
      setMode(defaultMode);
    }

    if (rosterPasteInput && rosterRowsContainer) {
      var handleRosterPaste = function () {
        var parsed = parseRosterText(rosterPasteInput.value);
        if (!parsed.length) return;
        applyParsedRoster(parsed);
        rosterPasteInput.value = '';
        updateQuantityNote();
      };

      rosterPasteInput.addEventListener('paste', function () {
        setTimeout(handleRosterPaste, 0);
      });

      rosterPasteInput.addEventListener('blur', handleRosterPaste);
    }

    if (rosterCopyButton && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      var copyResetTimer;
      rosterCopyButton.addEventListener('click', function () {
        var originalText = rosterCopyButton.textContent;
        navigator.clipboard.writeText(getInviteMessage()).then(function () {
          rosterCopyButton.textContent = '✅ Copied!';
          if (copyResetTimer) {
            clearTimeout(copyResetTimer);
          }
          copyResetTimer = setTimeout(function () {
            rosterCopyButton.textContent = originalText;
          }, 2000);
        });
      });
    }

    if (rosterRowsContainer) {
      rosterRowsContainer.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-roster-remove]');
        if (!removeBtn) return;
        var row = removeBtn.closest('[data-roster-row]');
        if (!row) return;
        row.parentNode.removeChild(row);
        rosterRows = container.querySelectorAll('[data-roster-row]');
        var nextQty = rosterRows.length;
        if (nextQty < 1) nextQty = 1;
        qtyInput.value = nextQty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateAll();
        updateQuantityNote();
      });

      rosterRowsContainer.addEventListener('input', function (e) {
        if (e.target && e.target.matches('input')) {
          updateQuantityNote();
        }
      });

      rosterRowsContainer.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input')) {
          updateQuantityNote();
        }
      });
    }

    if (rosterInputs && rosterInputs.length && (!rosterRows || rosterRows.length === 0)) {
      rosterInputs.forEach(function (input) {
        input.addEventListener('input', updateFromRosterInputs);
        input.addEventListener('change', updateFromRosterInputs);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-change-quantity');
      if (btn) scheduleUpdate();
    }, true);

    container.addEventListener('click', function (e) {
      var tier = e.target.closest('.tier-item');
      if (!tier) return;
      var min = parseInt(tier.getAttribute('data-tier-min'), 10);
      if (!isNaN(min)) {
        qtyInput.value = min;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateAll();
      }
    });

    if (!modeTabs || !modeTabs.length) {
      updateAll();
      updateQuantityNote();
    }

    updateDeliveryWindow();

    var lastQty = getQtyFromInput(qtyInput);
    setInterval(function () {
      var currentQty = getQtyFromInput(qtyInput);
      if (currentQty !== lastQty) {
        lastQty = currentQty;
        updateAll();
        updateQuantityNote();
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTeamDiscount);
  } else {
    initTeamDiscount();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initTeamDiscount);
  }
})();